var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-title",style:({'height' : _vm.titleHeight})},[_c('div',{staticStyle:{"display":"flex","height":"70px","align-items":"center"}},[_c('van-icon',{staticStyle:{"margin-right":"15px"},attrs:{"name":"arrow-left","size":"25"},on:{"click":_vm.back}}),_c('span',[_vm._v(" "+_vm._s(_vm.titleName)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }